import React from 'react';

import Card from '../../components/Card/Card';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import Table from '../../components/Table/Table';
import TablePreRender from '../../components/Table/Table.prerender';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';

import { RISK_ALLOCATION } from './queries';
import { riskAllocationUtil } from './util';

import styles from './RiskAllocation.css';

const RiskAllocation = ({ ticker }) => (
    <Card className="left">
        <div className="subsection-no-border">
            <GqlQueryWrapper
                query={RISK_ALLOCATION}
                variables={{ ticker }}
                dataFunc={riskAllocationUtil}
                placeholder={() => <TablePreRender />}
            >
                {({ data }) => (
                    <React.Fragment>
                        <TitleWithDescription
                            title="Risk Allocation"
                            rightText={() => `As of ${data.asOfDate}`}
                        />
                        <Table rowBars data={data} />
                    </React.Fragment>
                )}
            </GqlQueryWrapper>
        </div>

        <div className="risk-allocation-footer-text">
            * Total may not equal 100% due to rounding.
        </div>

        <style jsx>{styles}</style>
    </Card>
);

export default RiskAllocation;
